import { Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { useAuth } from 'react-oidc-context';
import { CircularProgress, Fab, Fade, Tooltip, Typography, styled, tooltipClasses } from '@mui/material';
import SessionExpiredModal from './SessionExpiredModal';
import HomeLayout from './HomeLayout';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const digitalWorkers = [
  {
    name: 'Gary',
    path: '/mydigitalworkers/gayatri/workpapers',
    description: 'workpaper',
  },
  {
    name: 'Scout',
    path: '/mydigitalworkers/scout/requests',
    description: 'report retrival',
  },
  {
    name: 'Omni',
    path: '/mydigitalworkers/omni/reports',
    description: 'business comm',
  },
  {
    name: 'Eva',
    path: '/mydigitalworkers/Eva/reports',
    description: 'individual comm',
  },
  {
    name: 'Atlas',
    path: '/mydigitalworkers/Atlas/reports',
    description: 'document classifier',
  },
];

export default function Header40({ imgClass, menuBarOpen, menuBarClose }) {
  const navigate = useNavigate();
  const auth = useAuth(); // Get the authentication context
  const [
    workers,
    setWorkers,
  ] = useState(digitalWorkers);
  const [
    isLoading,
    setIsLoading,
  ] = useState(false); // To indicate the loading state

  const [
    totalClients,
    setTotalClients,
  ] = useState(0);
  const [
    totalWorkpapers,
    setTotalWorkpapers,
  ] = useState(0);
  const [
    totalScoutRequests,
    setTotalScoutRequests,
  ] = useState(0);
  const [
    totalOmniDocs,
    setTotalOmniDocs,
  ] = useState(0);
  const [
    totalEvaDocs,
    setTotalEvaDocs,
  ] = useState(0);

  const location = useLocation();

  const tabs = [
    {
      name: 'Home',
      route: '/',
      onClick: () => { navigate('/'); },
    },
    {
      name: 'Clients',
      routeInclude: 'clients',
      onClick: () => { navigate('/clients'); },
    },
    {
      name: 'Settings',
      routeInclude: 'settings',
      onClick: () => { navigate('/setting'); },
    },
  ];

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  };

  const [
    windowDimensions,
    setWindowDimensions,
  ] = useState(getWindowDimensions());

  const scrollToMyDigitalWorker = () => {
    window.scrollTo(0, windowDimensions.height);
  };

  useEffect(() => {
    //   setIsLoading(true);

    //   fetch(`${window.origin}/api/digital-workers`, {
    //     method: 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Bearer ${auth.user?.access_token}`
    //     },
    // })
    // .then((response) => {
    //     if(response.status === 403){
    //         setSessionExpired(true)
    //         throw new Error('Session expired');
    //     }
    //     return response.json();
    // })
    // .then((data) => {
    //     // Mapping 'url' to 'path'
    //     console.log(data.data)
    //     const adjustedData = data.data.map(worker => ({
    //         ...worker,
    //         path: worker.url
    //     }));
    //     console.log(adjustedData)
    //     setWorkers(adjustedData);
    //     setIsLoading(false);
    // })
    // .catch((error) => {
    //     console.error('Failed to fetch workers:', error);
    // });

    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [auth]);

  useEffect(() => {
    if (!auth.user?.access_token) return;

    fetch(`${window.origin}/api/client`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${auth.user.access_token}`,
      },
    })
      .then(res => res.json())
      .then((data) => {
        // if API returns array of clients
        setTotalClients(Array.isArray(data) ? data.length : 0);
      })
      .catch((err) => {
        console.error('Error fetching client data:', err);
        setTotalClients(0);
      });
  }, [
    auth.user?.access_token,
    location.key,
  ]);

  useEffect(() => {
    if (!auth.user?.access_token) return;

    fetch(`${window.origin}/api/creator/request-groups`, {
      headers: {
        Authorization: `Bearer ${auth.user.access_token}`,
      },
    })
      .then(res => res.json())
      .then((data) => {
        setTotalWorkpapers(Array.isArray(data) ? data.length : 0);
      })
      .catch(() => setTotalWorkpapers(0));
  }, [auth.user?.access_token]);

  useEffect(() => {
    if (!auth.user?.access_token) return;

    fetch(`${window.origin}/api/reporter/requests`, {
      headers: {
        Authorization: `Bearer ${auth.user.access_token}`,
      },
    })
      .then(res => res.json())
      .then((data) => {
        setTotalScoutRequests(Array.isArray(data) ? data.length : 0);
      })
      .catch(() => setTotalScoutRequests(0));
  }, [auth.user?.access_token]);

  useEffect(() => {
    if (!auth.user?.access_token) return;

    fetch(`${window.origin}/api/client-communication`, {
      headers: { Authorization: `Bearer ${auth.user.access_token}` },
    })
      .then(res => res.json())
      .then((data) => {
        const reports = data?.data || data || [];

        setTotalOmniDocs(
          reports.length,
        );
      })
      .catch(() => {
        setTotalOmniDocs(0);
      });
  }, [auth.user?.access_token]);

  useEffect(() => {
    if (!auth.user?.access_token) return;

    fetch(`${window.origin}/api/Omni2`, {
      headers: { Authorization: `Bearer ${auth.user.access_token}` },
    })
      .then(res => res.json())
      .then((data) => {
        const reports = data?.data || data || [];

        setTotalEvaDocs(
          reports.length,
        );
      })
      .catch(() => {
        setTotalEvaDocs(0);
      });
  }, [auth.user?.access_token]);

  // if(windowDimensions.height < windowDimensions.width)
  return (
    <>

      <div className={imgClass} style={{ textAlign: 'center', position: 'relative', height: 'calc(100vh - 5vw)', flexDirection: 'row' }}>
        {!isLoading && (
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: 'calc(100vh - 5vw)', position: 'absolute' }}>
            {/* home page */}
            <div
              className="home-page"
              style={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                textAlign: 'left',
                justifyContent: 'center',
                flexDirection: window.innerWidth <= 768 ? 'column' : 'column',
              }}
            >
              <div
                style={{
                  margin: '1.5vw 1.5vw',
                  display: 'flex',
                  alignItems: 'center',
                  // backgroundImage: `url(${HomeBG})`,
                  flex: 1,
                  // backgroundSize: 'contain',
                  // backgroundRepeat: 'no-repeat',
                  // backgroundPosition: 'right',
                  flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
                }}
              >
                <div style={{ flex: 1, marginLeft: '4vw', paddingBottom: '2vw' }}>
                  <span style={{ backgroundColor: 'rgb(255, 255, 255, .8)', padding: '0.5vw 1vw', fontSize: '1vw', borderRadius: '10vw', marginBottom: '2vw' }}>Welcome</span>
                  <p style={{ marginTop: '2vw', marginBottom: '2.5vw', fontSize: '4vw', color: 'rgb(255, 255, 255, 0.9)', letterSpacing: '0.25vw', lineHeight: '5vw', fontWeight: '300', textShadow: 'rgb(0, 0, 0, 0.2) 1px 0 10px' }}>
                    Maximise your productivity
                  </p>
                  <div
                    style={{
                      width: '100%',
                      fontWeight: '300',
                      color: 'rgb(255, 255, 255, 0.8)',
                      fontSize: '1vw',
                      borderLeft: '0.15vw solid rgb(255, 255, 255, 0.9)',
                      paddingLeft: '0.9vw',
                      textShadow: 'rgb(0, 0, 0, 0.2) 1px 0 10px',
                    }}
                  >
                    <p style={{ margin: 0 }}>Digital workers with advanced intelligence streamline industries by managing </p>
                    <p style={{ margin: 0 }}>repetitive tasks, interacting with humans, and providing analytics. </p>

                  </div>
                  {/* <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2.5vw'}}>
                                                <ArrowDownwardOutlinedIcon onClick={scrollToMyDigitalWorker} style={{fontSize: '0.7vw', border: '1px solid rgb(255, 255, 255, 0.1)', backgroundColor: 'rgb(0, 0, 0, 0.15)', borderRadius: '10vw', height: '2.8vw',  width: '2.8vw', padding: '0.5vw', cursor: 'pointer', color: 'rgb(255, 255, 255, 0.7)', backdropFilter: 'blur(50px)', '-webkit-backdrop-filter': 'blur(50px)',}}/>
                                                <div style={{marginLeft: '1.25vw', color: 'rgb(255, 255, 255, 0.8)', fontSize: '0.9vw'}}>My Digital Workers</div>
                                              </div> */}
                </div>

                <div style={{ color: 'rgb(255, 255, 255, 0.9)', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyItems: 'center', alignItems: 'center', marginRight: '2vw', paddingBottom: '2vw' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyItems: 'center' }}>
                    <div style={{ 'backdropFilter': 'blur(50px)',
                      '-webkit-backdrop-filter': 'blur(50px)', 'marginLeft': '1vw', 'display': 'flex', 'flexDirection': 'row', 'width': '20vw', 'alignItems': 'center', 'justifyContent': 'space-between', 'backgroundColor': 'rgb(255, 255, 255, 0.8)', 'color': 'rgb(0, 0, 0, 0.9)', 'padding': '1.5vw 2vw', 'borderRadius': '1vw' }}
                    >
                      <p style={{ fontSize: '1.2vw', marginBottom: '0vw' }}>Total Clients</p>
                      <p style={{ fontSize: '1.5vw', marginBottom: '0vw', fontWeight: '400' }}>{totalClients}</p>

                    </div>
                    <div style={{ 'backdropFilter': 'blur(50px)',
                      '-webkit-backdrop-filter': 'blur(50px)', 'marginLeft': '1vw', 'display': 'flex', 'flexDirection': 'row', 'width': '20vw', 'alignItems': 'center', 'justifyContent': 'space-between', 'backgroundColor': 'rgb(255, 255, 255, 0.8)', 'color': 'rgb(0, 0, 0, 0.9)', 'padding': '1.5vw 2vw', 'borderRadius': '1vw' }}
                    >
                      <p style={{ fontSize: '1.2vw', marginBottom: '0vw' }}>ATO Reports</p>
                      <p style={{ fontSize: '1.5vw', marginBottom: '0vw', fontWeight: '400' }}>{totalScoutRequests}</p>

                    </div>

                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyItems: 'center', alignItems: 'center', marginTop: '1vw' }}>

                    <div style={{ 'backdropFilter': 'blur(50px)',
                      '-webkit-backdrop-filter': 'blur(50px)', 'marginLeft': '1vw', 'display': 'flex', 'flexDirection': 'row', 'width': '20vw', 'alignItems': 'center', 'justifyContent': 'space-between', 'backgroundColor': 'rgb(255, 255, 255, 0.8)', 'color': 'rgb(0, 0, 0, 0.9)', 'padding': '1.5vw 2vw', 'borderRadius': '1vw' }}
                    >
                      <p style={{ fontSize: '1.2vw', marginBottom: '0vw' }}>Workpapers</p>
                      <p style={{ fontSize: '1.5vw', marginBottom: '0vw', fontWeight: '400' }}>{totalWorkpapers}</p>

                    </div>
                    <div style={{ 'backdropFilter': 'blur(50px)',
                      '-webkit-backdrop-filter': 'blur(50px)', 'marginLeft': '1vw', 'display': 'flex', 'flexDirection': 'row', 'width': '20vw', 'alignItems': 'center', 'justifyContent': 'space-between', 'backgroundColor': 'rgb(255, 255, 255, 0.8)', 'color': 'rgb(0, 0, 0, 0.9)', 'padding': '1.5vw 2vw', 'borderRadius': '1vw' }}
                    >
                      <p style={{ fontSize: '1.2vw', marginBottom: '0vw' }}>Communications</p>
                      <p style={{ fontSize: '1.5vw', marginBottom: '0vw', fontWeight: '400' }}>{totalOmniDocs + totalEvaDocs}</p>

                    </div>

                  </div>
                </div>
              </div>
              <div
                className="quick-access"
                style={{
                  marginTop: window.innerWidth <= 768 ? '2vh' : '2vh',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: '10vw',
                  paddingRight: '2.5vw',
                  paddingLeft: '2.5vw',
                  marginLeft: window.innerWidth <= 768 ? '2vw' : '3vw',
                  marginBottom: window.innerWidth <= 768 ? '2vh' : '2vw',
                  marginRight: window.innerWidth <= 768 ? '2vw' : '3vw',

                }}
              >
                <div

                  id="digital-worker-quick-access"

                  style={{
                    'display': 'flex',
                    'flexDirection': 'row',
                    'backgroundColor': 'rgb(255, 255, 255, 0.7)',
                    'border': '1px solid rgb(255, 255, 255, 0.1)',
                    'padding': '1vw 0vw 1vw 1vw',
                    'borderRadius': '2vw',
                    'backdropFilter': 'blur(50px)',
                    '-webkit-backdrop-filter': 'blur(50px)',
                    'textAlign': 'center',
                    'boxShadow': '0 15px 15px hsl(0deg 0% 0% / 0.1)',
                  }}
                >
                  {workers.slice(0, 4).map((worker, index) => (
                    <div id={`quick-access-${worker.name}`} name={worker.name} key={index} style={{ display: 'flex', flexDirection: 'column', padding: '0px 1vw 0px 0px' }}>
                      <HtmlTooltip
                        title={(
                          <React.Fragment>
                            <Typography color="inherit">{worker.name}</Typography>
                            {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '} */}
                            Click here to access your digital worker
                          </React.Fragment>
                        )}
                      >
                        <div
                          onClick={() => navigate(worker.path)}
                          style={{
                            width: '20vw',
                            height: '9vw',
                            borderRadius: '1vw',
                            backgroundColor: 'rgb(255, 255, 255, 0)',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',

                            boxShadow: '0 10px 10px hsl(0deg 0% 0% / 0.08)',
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'start',

                          }}
                        >
                          <div style={{
                            flex: 1,
                            width: '100%',
                            height: '9vw',
                            borderRadius: '1.2vw',
                            backgroundImage: `linear-gradient(340deg, rgb(255, 255, 255, 0.4), rgb(255, 255, 255, 0.8))`,
                            border: '0.07vw solid rgb(255, 255, 255, 0)',
                            // backgroundColor: `rgb(255, 255, 255, 0.1)`,
                            // backdropFilter: 'blur(30px)',
                            // '-webkit-backdrop-filter': 'blur(30px)',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',

                          }}
                          >
                            <p style={{ margin: 0, fontSize: '2.4vw', fontWeight: '400', color: 'rgb(0, 15, 30, 0.8)', lineHeight: '2.5vw', letterSpacing: '0.01vw' }}>{worker.name}</p>
                            <p style={{ margin: 0, fontSize: '1.6vw', fontWeight: '300', color: 'rgb(0, 15, 30, 0.6)' }}>{worker.description}</p>

                          </div>
                          {/* <p style={{fontSize: '0.8vw', margin: '0.5vw', background: 'rgb(0, 0, 0, 0.2)', padding: '0.3vw 0.8vw', borderRadius: '5vw'}}>{worker.name}</p> */}
                        </div>
                      </HtmlTooltip>

                    </div>
                  ))}

                </div>
              </div>
            </div>
          </div>
        )}

        <Fade in={isLoading}>
          <div style={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', webkitBackdropFilter: 'blur(30px)', backdropFilter: 'blur(30px)', backgroundColor: 'rgb(255, 255, 255, 0.06)', position: 'absolute', zIndex: '1' }}>
            <CircularProgress color="inherit" />
          </div>
        </Fade>

      </div>

      {/* {!isLoading && <MyDigitalWorker/>} */}
    </>
  );
}
